/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `INSUFFICIENT_SURVEYING` - Nedostatečné zaměření
 *   * `ATTRIBUTE_ATTACHMENT_MISMATCH` - Nekorektní příloha
 *   * `OTHER` - Jiné
 *   * `INCOMPLETE_DOCUMENTATION` - Nekompletní dokumentace
 *   * `AZI_CHECK_FAILED` - Neproběhlo ověření AZI
 *   * `BAD_ATTACHMENT` - Nekorektní příloha
 * ```
 */
export const RejectionReasonEnum = {
  INSUFFICIENT_SURVEYING: 'INSUFFICIENT_SURVEYING',
  ATTRIBUTE_ATTACHMENT_MISMATCH: 'ATTRIBUTE_ATTACHMENT_MISMATCH',
  OTHER: 'OTHER',
  INCOMPLETE_DOCUMENTATION: 'INCOMPLETE_DOCUMENTATION',
  AZI_CHECK_FAILED: 'AZI_CHECK_FAILED',
  BAD_ATTACHMENT: 'BAD_ATTACHMENT',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RejectionReasonEnum = ValuesOf<typeof RejectionReasonEnum>;

export type RejectionReasonEnumRequest = RejectionReasonEnum;
export type RejectionReasonEnumResponse = RejectionReasonEnum;
